export const telefono = '011 5199 4706';
export const whatsApp = '+54 9 11 2762 3628';